<template>
    <div class="not-found">
        <slot/>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>
    .not-found {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }
</style>

